var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
/**
 * CalendarNavigation Component
 * Renders navigation controls (prev/next buttons, title)
 */
import React, { memo, useCallback } from 'react';
import { styles } from './CalendarNavigation.styles';
import { EventLegend } from '../EventLegend/EventLegend';
/**
 * CalendarNavigation - Navigation header for calendar
 */
export const CalendarNavigation = memo(({ title, mode, disabled = false, hideNav = false, disableModeToggle = false, onPrevious, onNext, onToday, onTitleClick, showTodayButton = true, prevAriaLabel = 'Previous', nextAriaLabel = 'Next', onBackClick, backLabel = 'Back to new calendar', legendItems, }) => {
    // Handle previous click
    const handlePrevious = useCallback(() => {
        if (!disabled) {
            onPrevious === null || onPrevious === void 0 ? void 0 : onPrevious();
        }
    }, [disabled, onPrevious]);
    // Handle next click
    const handleNext = useCallback(() => {
        if (!disabled) {
            onNext === null || onNext === void 0 ? void 0 : onNext();
        }
    }, [disabled, onNext]);
    // Handle title click
    const handleTitleClick = useCallback(() => {
        if (!disableModeToggle) {
            onTitleClick === null || onTitleClick === void 0 ? void 0 : onTitleClick();
        }
    }, [disableModeToggle, onTitleClick]);
    // Handle today click
    const handleTodayClick = useCallback(() => {
        onToday === null || onToday === void 0 ? void 0 : onToday();
    }, [onToday]);
    // Handle keyboard on title
    const handleTitleKeyDown = useCallback((e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleTitleClick();
        }
    }, [handleTitleClick]);
    return (React.createElement("div", { style: styles.container, role: "navigation", "aria-label": "Calendar navigation" },
        React.createElement("div", { style: styles.leftSpacer }),
        React.createElement("div", { style: styles.navButtons },
            !hideNav && (React.createElement("button", { style: Object.assign(Object.assign({}, styles.navButton), (disabled ? styles.navButtonDisabled : {})), onClick: handlePrevious, disabled: disabled, "aria-label": prevAriaLabel, type: "button" }, "\u2039")),
            React.createElement("div", { style: Object.assign(Object.assign({}, styles.title), (disableModeToggle ? {} : styles.titleClickable)), onClick: handleTitleClick, onKeyDown: handleTitleKeyDown, role: disableModeToggle ? undefined : 'button', tabIndex: disableModeToggle ? undefined : 0, "aria-label": disableModeToggle ? title : `${title}. Click to change view.`, "aria-live": "polite" }, title),
            !hideNav && (React.createElement("button", { style: Object.assign(Object.assign({}, styles.navButton), (disabled ? styles.navButtonDisabled : {})), onClick: handleNext, disabled: disabled, "aria-label": nextAriaLabel, type: "button" }, "\u203A"))),
        React.createElement("div", { style: styles.rightGroup },
            onBackClick && (React.createElement("button", { style: styles.backLink, onClick: onBackClick, type: "button" }, backLabel)),
            React.createElement(EventLegend, { buttonLabel: "EVENT LEGEND", items: legendItems }))));
});
CalendarNavigation.displayName = 'CalendarNavigation';
export default CalendarNavigation;
//# sourceMappingURL=CalendarNavigation.js.map